import React from "react";

export const Divider = () => {
  return (
    <div className="cw-pl-6 cw-pr-3">
      <div className="cw-w-full cw-border-t-[0.5px] cw-border-solid cw-border-subtle" />
    </div>
  );
};
